<template>
    <div class="attendanceLog">
        <div class="key_top " v-if="permisShow('查看考勤日志')">
            <ul class="key_list">
                <li class="conditions_list_item">
                    <span>关键字：</span>
                    <el-input
                        v-model="search.content"
                        @input="pageNumber=1,queryAttendancelog()"
                        placeholder="请输入操作内容"
                        clearable
                    ></el-input>
                </li>
                <span style="color:#ff0000">（如果需要多个搜索条件，中间用,号分隔）</span>
            </ul>
        </div>
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" v-if="permisShow('查看考勤日志')" highlight-current-row>
                <el-table-column prop="employeeName" label="操作人"></el-table-column>
                <el-table-column prop="operationTime" label="操作时间"></el-table-column>
                <el-table-column prop="content" label="操作内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">{{scope.row.remark}}</template>
                </el-table-column>
            </el-table>
            <div class="footer_page" v-if="permisShow('查看考勤日志')">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, sizes, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { queryAttendancelog } from "@/api/checkingIn";
import { getRouterLevel } from "@/vue/util/tool";
export default {
    name:'/attendanceLog',
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            search: {
                content: "",
                permissionLevel: sessionStorage.getItem("permisListlevel")
            },
            List: [], //跟进列表
            total: 0,
            currentPage: 1,
            pageNumber: 1,
            pageSize: 20,
            total: 0
        };
    },

    mounted() {
        this.queryAttendancelog();
    },

    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        queryAttendancelog() {
            // 查看考勤日志考勤统计查询
            let params = Object.assign({}, this.search);
            params["page.pageNumber"] =
                this.pageNumber * this.pageSize - this.pageSize;
            params["page.pageSize"] = this.pageSize;
            let result = this.permisShow("查看考勤日志");
            if (!result) {
                params.permissionLevel = 6;
            }else{
                params.permissionLevel = getRouterLevel("查看考勤日志");
            }
            this.$post(queryAttendancelog, params).then(res => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleSizeChange(val) {
            this.pageNumber = 1;
            this.pageSize = val;
            this.queryAttendancelog();
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryAttendancelog();
        }
    }
};
</script>

<style lang="less">
.attendanceLog {
    height: 100%;
    .key_top {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        background: #fff;

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }
    }
    .key_list {
        display: flex;
        align-items: center;
        color: #ff0000;
        .conditions_list_item {
            background: #f5f5f5;
            padding: 0 0 0 10px;
            display: flex;
            align-items: center;
            margin-right: 20px;
            position: relative;
            cursor: pointer;
            .departpop {
                width: 170px;
                position: absolute;
                left: 0;
                top: 41px;
                z-index: 10;
                border: 1px solid #eee;
                .tree-item {
                    display: flex;
                    align-items: center;
                    img {
                        padding-right: 10px;
                    }
                }
            }
            > span {
                line-height: 20px;
                border-right: 1px solid #ccc;
                font-size: 12px;
                color: #5e75e6;
                padding: 0;
                padding-right: 10px;
            }
            .el-input {
                width: 160px;
                height: 30px;
                .el-input-group__append,
                .el-input-group__prepend {
                    padding: 0 10px;
                    background: #cccccc;
                    border: none;
                }

                .el-input__inner {
                    border: none;
                    height: 30px;
                    background: #f5f5f5;
                }

                .icon-icon_sousuo {
                    color: white;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        width: 100px;
                        height: 30px;
                        border: none;
                        background: #f5f5f5;
                        color: black;
                        padding: 0;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .total_inp {
                border: none;
                display: flex;
                align-items: center;
                height: 30px;
                width: 220px;
                padding-right: 0;
                .el-date-editor {
                    border: none;
                    background: #f5f5f5;
                    width: 220px;
                }
                .el-range-input {
                    background: #f5f5f5;
                }
            }
        }
    }
}
</style>